<template>
  <div class="banner__wrapper" ref="bannerWrapper">
    <div
      v-if="isVisible"
      :class="`banner banner--${variant}`"
      @scroll.passive="handleScroll"
      ref="banner"
    >
      <img
        v-if="variant === NOTIFICATION_VARIANTS.INFO"
        src="@/assets/images/icons/icon-check-circle.svg"
        alt="image"
        class="banner__icon"
      />

      <img
        v-if="variant === NOTIFICATION_VARIANTS.ERROR"
        src="@/assets/images/icons/icon-notification.svg"
        alt="image"
        class="banner__icon"
      />

      <div class="banner__content">
        <template v-if="texts.length">
          <template v-for="(item, i) in texts">
            <h6 v-if="i === 0" :key="`title-${i}`" class="banner__title mb-0">
              {{ item }}
            </h6>

            <p v-else :key="`text-${i}`" class="banner__text">
              {{ item }}
            </p>
          </template>
        </template>

        <template v-else>
          <h6 class="banner__title">{{ title }}</h6>
          <p class="banner__text">{{ text }}</p>
        </template>

        <slot></slot>
      </div>

      <img
        src="@/assets/images/icons/icon-close.svg"
        alt="close"
        class="banner__close-button"
        @click="handleClose"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount } from "vue";
import { NOTIFICATION_VARIANTS } from "@/const/bannerVariants";

const props = defineProps({
  variant: {
    type: String,
    default: NOTIFICATION_VARIANTS.INFO,
  },
  title: {
    type: String,
    default: "",
  },
  text: {
    type: String,
    default: "",
  },
  texts: {
    type: Array,
    default: () => [],
  },
  onClose: Function,
});

const isVisible = ref(true);
const bannerWrapper = ref(null);
const banner = ref(null);

const variant = computed(() => props.variant);
const title = computed(() => props.title);
const text = computed(() => props.text);
const texts = computed(() => props.texts);
const onClose = computed(() => props.onClose);

// Methods
const handleClose = () => {
  onClose.value();
};

const init = () => {
  onScroll();
  if (bannerWrapper.value && banner.value) {
    bannerWrapper.value.style.height = `${banner.value.getBoundingClientRect().height}px`;
  }
};

const onScroll = () => {
  if (banner.value) {
    banner.value.style.marginTop = `${window.scrollY}px`;
  }
};

// Lifecycle hooks
onMounted(() => {
  window.addEventListener("scroll", onScroll);
  onScroll();
  init();
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScroll);
});
</script>
